export const pageStatuses = {
    Live: 1,
    Completed: 2,
    Archived: 3
}